export default __webpack_public_path__ + "static/media/Bells.e2aef92c.wav";